import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { bootstrapLabTheme } from '@/lib/labTheme';
import { ensureThemePreviewFontsLoaded } from '@/lib/ensureThemePreviewFonts';
import { App } from './App';
import './index.css';

bootstrapLabTheme();
ensureThemePreviewFontsLoaded();

const root = document.getElementById('root');
if (root) {
  createRoot(root).render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>,
  );
}
